export class OrphanedBriefError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'OrphanedBriefError';
    }
}

export class DeprecatedRouteError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'DeprecatedRouteError';
    }
}

export class DuplicateBriefPurchaseError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'DuplicateBriefPurchaseError';
    }
}
